
import React, { useState, useEffect } from "react";
import { Button, Modal, Box, Paper, Snackbar } from "@mui/material";
import FornecedorFormulario from "./FornecedorFormulario";
import FornecedorTabela from "./FornecedorTabela";
import PermissionGate from "../CadastroPerfilUsuario/PermissionGate";
import URLManager from "../funcionalidadeNavbar/URLManager";

const Fornecedor = () => {
  const _url = URLManager.getBaseURL();

  const fornecedor = {
    id: 0,
    nomeEmpresa: "",
    telefone: "",
    cnpj: "",
    email: "",
    endereco: "",
    idEmpresa: 0,
  };

  const [objFornecedor, setObjFornecedor] = useState(fornecedor);
  const [btnFornecedor, setBtnFornecedor] = useState(true);
  const [fornecedores, setFornecedores] = useState([]);
  const [fornecedoresFiltradas, setFornecedoresFiltradas] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const mostrarMensagem = (mensagem) => {
    setSnackbarMessage(mensagem);
    setSnackbarOpen(true);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const aoDigitar = (e) => {
    setObjFornecedor({ ...objFornecedor, [e.target.name]: e.target.value });
  };

  const limparFornecedor = () => {
    setObjFornecedor(fornecedor);
    setBtnFornecedor(true);
  };

  

 useEffect(() => {
    carregarFornecedores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  const obterFornecedores = () => {
    fetch(`${_url}/fornecedor/listar`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`,
      },
    })
      .then((retorno) => retorno.json())
      .then((retorno_convertido) => {
        setFornecedores(retorno_convertido);
        setFornecedoresFiltradas(retorno_convertido);
      });
  };

  const cadastrar = () => {
    // Prepare payload: remove id and idEmpresa when not meaningful
    const { id, idEmpresa, ...payload } = objFornecedor;

    // If idEmpresa is 0 or null/undefined, do not include it - backend will use authenticated user's company
    if (idEmpresa && idEmpresa !== 0) {
      payload.idEmpresa = idEmpresa;
    }

    fetch(`${_url}/fornecedor/cadastrar`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`,
      },
    })
      .then(async (retorno) => {
        const text = await retorno.text();
        let body = null;
        try {
          body = text ? JSON.parse(text) : null;
        } catch (e) {
          // response not JSON
          body = text;
        }

        if (!retorno.ok) {
          // Log details for debugging
          console.error('Erro ao cadastrar fornecedor', retorno.status, body);
          if (body && body.mensagem) {
            mostrarMensagem(body.mensagem);
          } else if (typeof body === 'string' && body.length > 0) {
            mostrarMensagem(`Erro: ${body}`);
          } else {
            mostrarMensagem('Erro ao cadastrar fornecedor (ver console)');
          }
          return;
        }

        // sucesso
        const retorno_convertido = body;
        if (retorno_convertido && retorno_convertido.mensagem) {
          mostrarMensagem(retorno_convertido.mensagem);
        } else {
          // If backend returns Optional<Fornecedor> wrapped, try to handle both array/object
          const fornecedorCriado = retorno_convertido && retorno_convertido.value ? retorno_convertido.value : retorno_convertido;
          setFornecedores([...fornecedores, fornecedorCriado]);
          mostrarMensagem("Fornecedor cadastrado com sucesso!");
          carregarFornecedores();
          limparFornecedor();
          handleCloseModal();
        }
      })
      .catch((err) => {
        console.error('Falha na requisição cadastrar fornecedor', err);
        mostrarMensagem('Falha na requisição: ' + (err.message || err));
      });
  };

  const remover = () => {
    fetch(`${_url}/fornecedor/remover/${objFornecedor.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`,
      },
    })
      .then((retorno) => retorno.json())
      .then((retorno_convertido) => {
        mostrarMensagem(retorno_convertido.mensagem || "Fornecedor removido");
        carregarFornecedores();
        limparFornecedor();
        handleCloseModal();
      });
  };

const alterar = () => {
  // Cria uma cópia do objeto SEM o ID
  const { id, idEmpresa, ...dadosParaEnviar } = objFornecedor;
  
  fetch(`${_url}/fornecedor/alterar/${id}`, {
    method: "PUT",
    body: JSON.stringify(dadosParaEnviar), // Envia apenas os dados alteráveis
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`,
    },
  })
  .then((retorno) => {
    if (!retorno.ok) {
      throw new Error('Erro na requisição');
    }
    return retorno.json();
  })
  .then((retorno_convertido) => {
    // Atualiza a lista de fornecedores
    const updatedFornecedores = fornecedores.map(f => 
      f.id === id ? { ...f, ...dadosParaEnviar } : f
    );
    setFornecedores(updatedFornecedores);
    mostrarMensagem("Fornecedor alterado com sucesso!");
    limparFornecedor();
    carregarFornecedores();
    handleCloseModal();
  })
  .catch(error => {
    mostrarMensagem(error.message || "Erro ao alterar fornecedor");
  });
};

  const selecionarFornecedor = (id) => {
    const fornecedorSelecionado = fornecedores.find(forn => forn.id === id);
    setObjFornecedor(fornecedorSelecionado);
    setBtnFornecedor(false);
    handleOpenModal();
  };

  const filtrarFornecedor = (nomeEmpresa) => {
    const fornecedoresFiltradas = fornecedores.filter((fornecedor) =>
      fornecedor.nomeEmpresa.toLowerCase().includes(nomeEmpresa.toLowerCase())
    );
    setFornecedoresFiltradas(fornecedoresFiltradas);
  };

  const carregarFornecedores = () => {
    obterFornecedores();
  };

 
  return (
    <div>
      {/* Toolbar */}
      <div className="toolbar-inline toolbar-center">
        <PermissionGate permissions={["fornecedorCadastrar"]}>
          <Button variant="contained" onClick={handleOpenModal} className="modal-button modal-button-primary">
            Cadastrar Fornecedor
          </Button>
        </PermissionGate>
      </div>

      {/* Modal com o formulário de cadastro */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50% )',
            width: 450,
            maxHeight: '85vh',
            overflowY: 'auto',
            p: 3,
          }}
        >
          <Paper style={{ 
            padding: '15px', 
            color: '#333', 
            textAlign: 'center', 
            fontSize: '16px',
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div className="modal-title">
              {btnFornecedor ? 'Cadastrar Fornecedor' : 'Editar Fornecedor'}
            </div>

            <FornecedorFormulario
              botao={btnFornecedor}
              eventoTeclado={aoDigitar}
              cadastrar={cadastrar}
              obj={objFornecedor}
              remover={remover}
              alterar={alterar}
              filtrar={filtrarFornecedor}
            />
            
            <div className="modal-buttons">
              <button onClick={handleCloseModal} className='modal-button modal-button-close'>
                Fechar
              </button>
            </div>
          </Paper>
        </Box>
      </Modal>

      <FornecedorTabela
        vetor={fornecedoresFiltradas}
        selecionar={selecionarFornecedor}
        filtrar={filtrarFornecedor}
        vetrores={fornecedores}
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </div>
  );
};

export default Fornecedor;
